export default {
    data: () => ({
        translations: {
            title: {
                el: "Ρυθμίσεις Offline Συναλλαγών",
                en: "Offline Transaction Settings",
                it: "Ενημέρωση χρήστη για ποντοδοσία"
            },
            info: {
                el: "Οι ρυθμίσεις εδώ θα επηρεάσουν ποια πεδία εμφανίζονται στη σελίδα Νέα συναλλαγή.",
                en: `
                    These settings will impact which fields are displayed on the New Transactions page.
                `,
                it: "Queste impostazioni influiranno sui campi visualizzati nella pagina Nuove transazioni."
            },
            notifyConsumers: {
                el: "Ενημερώστε τον πελάτη σας για τους πόντους που κέρδισε μέσω:",
                en: "Notify your customer about the points they won through:",
                it: "Informa il tuo cliente sui punti guadagnati attraverso:"
            },
            selectProducts: {
                el: "Επιλέξτε τα προϊόντα που έχουν αγοραστεί",
                en: 'Specify the purchased products',
                it: "Specifica i prodotti acquistati"
            },
            receiptCode: {
                el: 'Να ζητάται ο κωδικού απόδειξης στη σελίδα "Νέα συναλλαγή"',
                en: 'Request receipt code on the page "New Transaction"',
                it: 'Richiedi il codice della ricevuta alla pagina "Nuova transazione"'
            },
            receiptCodeScan: {
                el: 'Ο κωδικός απόδειξης μπορεί να συμπληρωθεί μόνο με σάρωση.',
                en: 'The receipt code can be filled only by scanning.',
                it: 'Il codice della ricevuta può essere compilato solo tramite scansione.'
            },
            rewardPoints: {
                el: "Γενική απόδοση πόντων:",
                en: 'General points attribution:',
                it: "Attribuzione generale dei punti:"
            },
            systemNotification: {
                el: "Ενημέρωση χρήστη για ποντοδοσία:",
                en: 'How to notify  user for points:',
                it: "Come notificare all'utente i punti:"
            },
            agreeToTerms: {
                el: "Αποδοχή Όρων Χρήσης & Πολιτικής Απορρήτου με 4ψήφιο κωδικό pin",
                en: 'Agree to terms & conditions through verification sms',
                it: "Accettare i termini e le condizioni tramite sms di verifica"
            },
            euro: {
                el: "ευρώ",
                en: 'euros',
                it: "euro"
            },
            currency: {
                el: "ποσό",
                en: 'currency',
                it: "valuta"
            },
            assign: {
                el: "Εκχώρησε ",
                en: 'Assign',
                it: "Assegnare"
            },
            per: {
                el: "ανά",
                en: 'per',
                it: "per"
            },
            points: {
                el: "πόντοι",
                en: 'points',
                it: "punti"
            },
            round: {
                el: "round",
                en: 'round',
                it: "round"
            },
            up: {
                el: "round",
                en: 'round',
                it: "round"
            },
            down: {
                el: "round",
                en: 'round',
                it: "round"
            }
        }
    })
};
